import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { testEnvironments } from '@/constants'

// Import icons
import '@fortawesome/fontawesome-pro/css/all.css'

// Import locale
import nl from '@/i18n/nl'
import en from '@/i18n/en'
import de from '@/i18n/de'
import fr from '@/i18n/fr'

Vue.use(Vuetify)

const ICONS = {
  close: 'fal fa-times',
  delete: 'fal fa-trash',
  clear: 'fal fa-times',
  success: 'fal fa-check',
  info: 'fal fa-info',
  warning: 'fal fa-exclamation',
  error: 'fal fa-times',
  prev: 'fal fa-long-arrow-left',
  next: 'fal fa-long-arrow-right',
  sort: 'fal fa-sort-size-down-alt',
  menu: 'fal fa-bars',
  dropdown: 'fal fa-chevron-down',
  edit: 'fal fa-edit',
  ratingEmpty: 'fal fa-star',
  ratingFull: 'fas fa-star',
  ratingHalf: 'fas fa-star-half',
  loading: 'fal fa-spinner-third'
}

export const tracefyBlue = '#173C60'
export const tracefyOrange = '#c97200'
export const tracefyOrangeDisabled = '#8a8074'
export const primary = testEnvironments.some(v => location.host.includes(v)) ? '#2d4c4d' : tracefyBlue
export const primaryDarker = '#112d47'
export const white = '#fff'
export const black = '#000000'
export const lightSecondary = '#f5f5f5'
export const darkPrimary = '#272727'
export const darkSecondary = '#545454'
export const danger = '#bf3e3b'
export const success = '#479d2d'
export const darkSuccess = '#1cad73'

export default new Vuetify({
  icons: {
    iconfont: 'fa',
    values: ICONS
  },
  lang: {
    locales: { nl, de, en, fr },
    current: 'en'
  },
  theme: {
    options: {
      customProperties: true
    },
    dark: false,
    themes: {
      light: {
        primary,
        secondary: tracefyOrange,
        warning: tracefyOrange,
        buttonColor: primary,
        treeview: primary,
        bgSecondary: '#e4e8ec',
        accentColor: tracefyBlue,
        noticeBg: lightSecondary,
        lightSecondary,
        tracefyOrange,
        tracefyBlue,
        primaryDarker,
        primaryBg: white,
        success,
        danger,
        white
      },
      dark: {
        primary: darkPrimary,
        secondary: tracefyOrange,
        success: darkSuccess,
        buttonColor: darkSuccess,
        labelColor: '#f1f1f1',
        warning: tracefyOrange,
        treeview: darkSecondary,
        bgSecondary: darkSecondary,
        accentColor: tracefyOrange,
        primaryBg: darkPrimary,
        noticeBg: '#1e1e1e',
        tracefyOrange,
        tracefyBlue,
        primaryDarker,
        danger,
        white
      }
    }
  }
})
